export const CONDITION_DELETE_RESET = 'CONDITION_DELETE_RESET'
export const CONDITION_DELETE_SET_ERROR = 'CONDITION_DELETE_SET_ERROR'
export const CONDITION_DELETE_SET_DELETED = 'CONDITION_DELETE_SET_DELETED'
export const CONDITION_DELETE_TOGGLE_LOADING = 'CONDITION_DELETE_TOGGLE_LOADING'
